/** Auto-generated master screen entries — plan §1.2 (94 MS). Do not edit by hand; run generate-master-screen-registry.mjs */
import type { MasterScreenEntry } from './masterScreenRegistry.types.js';

export const MASTER_SCREEN_ENTRIES: readonly MasterScreenEntry[] = [
  {
    "id": "MS-ENTRY-001",
    "name": "Tenant Select Screen",
    "surfaceKind": "route",
    "screenGroup": "ENTRY",
    "businessPurpose": "Tenant Select Screen",
    "businessCapabilityId": "CAP-ENTRY-001",
    "primaryOutcome": "Customer selects tenant and enters tenant-scoped PWA",
    "domain": "Entry",
    "journey": "J-TENANT-SELECT",
    "identityRequired": "IS-01",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "/",
    "routeComponent": "TenantSelectScreen",
    "blueprintId": "BP-ENTRY-001",
    "analyticsScreenName": "ms_entry_001",
    "i18nKeyPrefix": "retail.entry.tenantSelect",
    "p29SectionRef": "PROMPT29:MS-ENTRY-001",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ENTRY-002",
    "name": "Surface Unavailable",
    "surfaceKind": "route",
    "screenGroup": "ENTRY",
    "businessPurpose": "Surface Unavailable",
    "businessCapabilityId": "CAP-ENTRY-002",
    "primaryOutcome": "Customer understands surface is unavailable and can exit or retry later",
    "domain": "Entry",
    "journey": "J-SHARED",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "unavailable",
    "routeComponent": "SurfaceUnavailableScreen",
    "blueprintId": "BP-ENTRY-002",
    "analyticsScreenName": "ms_entry_002",
    "i18nKeyPrefix": "retail.entry.unavailable",
    "p29SectionRef": "PROMPT29:MS-ENTRY-002",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ENTRY-003",
    "name": "Public Shops Directory",
    "surfaceKind": "route",
    "screenGroup": "ENTRY",
    "businessPurpose": "Public Shops Directory",
    "businessCapabilityId": "CAP-ENTRY-003",
    "primaryOutcome": "Customer browses public cross-tenant shops directory",
    "domain": "Entry",
    "journey": "J-SHARED",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "/shops",
    "routeComponent": "ShopsDirectoryScreen",
    "blueprintId": "BP-ENTRY-003",
    "analyticsScreenName": "ms_entry_003",
    "i18nKeyPrefix": "retail.entry.shops",
    "p29SectionRef": "PROMPT29:MS-ENTRY-003",
    "productLifecycle": "Registered",
    "certificationStatus": "content-complete"
  },
  {
    "id": "MS-SYS-001",
    "name": "Legacy Confirm Email Redirect",
    "surfaceKind": "redirect",
    "screenGroup": "SYSTEM",
    "businessPurpose": "Legacy Confirm Email Redirect",
    "businessCapabilityId": "CAP-AUTH-001",
    "primaryOutcome": "Legacy confirm-email URL lands on current confirm-email route",
    "domain": "System",
    "journey": "J-AUTH",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "sign-up/confirm-email",
    "routeComponent": "LegacyConfirmEmailRedirect",
    "blueprintId": "BP-SYS-001",
    "analyticsScreenName": "ms_sys_001",
    "i18nKeyPrefix": "retail.sys.legacyConfirmEmail",
    "p29SectionRef": "PROMPT29:MS-SYS-001",
    "supersedes": [
      "MS-AUTH-018"
    ],
    "aliasMsIds": [
      "MS-AUTH-018"
    ],
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-SYS-002",
    "name": "Account Home Redirect",
    "surfaceKind": "redirect",
    "screenGroup": "SYSTEM",
    "businessPurpose": "Account Home Redirect",
    "businessCapabilityId": "CAP-ACC-001",
    "primaryOutcome": "Account /home alias redirects to account home surface",
    "domain": "System",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account/home",
    "routeComponent": "Navigate",
    "blueprintId": "BP-SYS-002",
    "analyticsScreenName": "ms_sys_002",
    "i18nKeyPrefix": "retail.sys.accountHomeRedirect",
    "p29SectionRef": "PROMPT29:MS-SYS-002",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-SYS-003",
    "name": "Account Privacy Redirect",
    "surfaceKind": "redirect",
    "screenGroup": "SYSTEM",
    "businessPurpose": "Account Privacy Redirect",
    "businessCapabilityId": "CAP-ACC-001",
    "primaryOutcome": "Account /privacy alias redirects to account-and-privacy surface",
    "domain": "System",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account/privacy",
    "routeComponent": "Navigate",
    "blueprintId": "BP-SYS-003",
    "analyticsScreenName": "ms_sys_003",
    "i18nKeyPrefix": "retail.sys.accountPrivacyRedirect",
    "p29SectionRef": "PROMPT29:MS-SYS-003",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-SYS-004",
    "name": "Account Settings Redirect",
    "surfaceKind": "redirect",
    "screenGroup": "SYSTEM",
    "businessPurpose": "Account Settings Redirect",
    "businessCapabilityId": "CAP-ACC-001",
    "primaryOutcome": "Account /settings alias redirects to account-and-privacy surface",
    "domain": "System",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account/settings",
    "routeComponent": "Navigate",
    "blueprintId": "BP-SYS-004",
    "analyticsScreenName": "ms_sys_004",
    "i18nKeyPrefix": "retail.sys.accountSettingsRedirect",
    "p29SectionRef": "PROMPT29:MS-SYS-004",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-SYS-005",
    "name": "Account Shop PM Redirect",
    "surfaceKind": "redirect",
    "screenGroup": "SYSTEM",
    "businessPurpose": "Account Shop PM Redirect",
    "businessCapabilityId": "CAP-ACC-001",
    "primaryOutcome": "Account /shop/pm alias redirects to account shop tenant surface",
    "domain": "System",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account/shop/pm",
    "routeComponent": "Navigate",
    "blueprintId": "BP-SYS-005",
    "analyticsScreenName": "ms_sys_005",
    "i18nKeyPrefix": "retail.sys.accountShopPmRedirect",
    "p29SectionRef": "PROMPT29:MS-SYS-005",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-SYS-006",
    "name": "Tenant Catch-All Redirect",
    "surfaceKind": "redirect",
    "screenGroup": "SYSTEM",
    "businessPurpose": "Tenant Catch-All Redirect",
    "businessCapabilityId": "CAP-ENTRY-001",
    "primaryOutcome": "Unknown tenant path recovers via access-denied or tenant select",
    "domain": "System",
    "journey": "J-AUTH",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "*",
    "routeComponent": "TenantCatchAllRedirect",
    "recoveryMsId": "MS-REC-074",
    "blueprintId": "BP-SYS-006",
    "analyticsScreenName": "ms_sys_006",
    "i18nKeyPrefix": "retail.sys.tenantCatchAll",
    "p29SectionRef": "PROMPT29:MS-SYS-006",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-AUTH-010",
    "name": "Sign In OTP",
    "surfaceKind": "route",
    "screenGroup": "AUTH",
    "businessPurpose": "Sign In OTP",
    "businessCapabilityId": "CAP-AUTH-010",
    "primaryOutcome": "Guest authenticates via OTP or password and resumes return target",
    "domain": "Auth",
    "journey": "J-AUTH",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "sign-in",
    "routeComponent": "SignInScreen",
    "recoveryMsId": "MS-REC-083",
    "blueprintId": "BP-AUTH-010",
    "analyticsScreenName": "ms_auth_010",
    "i18nKeyPrefix": "retail.auth.signIn",
    "p29SectionRef": "PROMPT29:MS-AUTH-010",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-AUTH-011",
    "name": "Register Screen",
    "surfaceKind": "route",
    "screenGroup": "AUTH",
    "businessPurpose": "Register Screen",
    "businessCapabilityId": "CAP-AUTH-011",
    "primaryOutcome": "New customer starts registration and reaches pending or signed-in state",
    "domain": "Auth",
    "journey": "J-AUTH",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "sign-up",
    "routeComponent": "RegisterScreen",
    "blueprintId": "BP-AUTH-011",
    "analyticsScreenName": "ms_auth_011",
    "i18nKeyPrefix": "retail.auth.signUp",
    "p29SectionRef": "PROMPT29:MS-AUTH-011",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-AUTH-012",
    "name": "Sign Up Pending",
    "surfaceKind": "route",
    "screenGroup": "AUTH",
    "businessPurpose": "Sign Up Pending",
    "businessCapabilityId": "CAP-AUTH-011",
    "primaryOutcome": "Unverified registrant waits for email confirmation with resend options",
    "domain": "Auth",
    "journey": "J-AUTH",
    "identityRequired": "IS-04",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "sign-up/pending",
    "routeComponent": "SignUpPendingScreen",
    "blueprintId": "BP-AUTH-012",
    "analyticsScreenName": "ms_auth_012",
    "i18nKeyPrefix": "retail.auth.signUpPending",
    "p29SectionRef": "PROMPT29:MS-AUTH-012",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-AUTH-013",
    "name": "Confirm Email",
    "surfaceKind": "route",
    "screenGroup": "AUTH",
    "businessPurpose": "Confirm Email",
    "businessCapabilityId": "CAP-AUTH-013",
    "primaryOutcome": "Email confirmation link verifies account and continues onboarding",
    "domain": "Auth",
    "journey": "J-AUTH",
    "identityRequired": "IS-04",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "confirm-email",
    "routeComponent": "ConfirmEmailScreen",
    "blueprintId": "BP-AUTH-013",
    "analyticsScreenName": "ms_auth_013",
    "i18nKeyPrefix": "retail.auth.confirmEmail",
    "p29SectionRef": "PROMPT29:MS-AUTH-013",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-AUTH-014",
    "name": "Onboarding Set Credentials",
    "surfaceKind": "route",
    "screenGroup": "AUTH",
    "businessPurpose": "Onboarding Set Credentials",
    "businessCapabilityId": "CAP-AUTH-014",
    "primaryOutcome": "Onboarding customer sets credentials and completes account activation",
    "domain": "Auth",
    "journey": "J-AUTH",
    "identityRequired": "IS-04",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "onboarding/set-credentials",
    "routeComponent": "OnboardingSetCredentialsScreen",
    "blueprintId": "BP-AUTH-014",
    "analyticsScreenName": "ms_auth_014",
    "i18nKeyPrefix": "retail.auth.setCredentials",
    "p29SectionRef": "PROMPT29:MS-AUTH-014",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-AUTH-015",
    "name": "Forgot Password",
    "surfaceKind": "route",
    "screenGroup": "AUTH",
    "businessPurpose": "Forgot Password",
    "businessCapabilityId": "CAP-AUTH-015",
    "primaryOutcome": "Customer requests password reset and receives reset delivery",
    "domain": "Auth",
    "journey": "J-AUTH",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "forgot-password",
    "routeComponent": "ForgotPasswordScreen",
    "blueprintId": "BP-AUTH-015",
    "analyticsScreenName": "ms_auth_015",
    "i18nKeyPrefix": "retail.auth.forgotPassword",
    "p29SectionRef": "PROMPT29:MS-AUTH-015",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-AUTH-016",
    "name": "Reset Password",
    "surfaceKind": "route",
    "screenGroup": "AUTH",
    "businessPurpose": "Reset Password",
    "businessCapabilityId": "CAP-AUTH-016",
    "primaryOutcome": "Customer sets a new password from a valid reset token",
    "domain": "Auth",
    "journey": "J-AUTH",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "reset-password",
    "routeComponent": "ResetPasswordScreen",
    "blueprintId": "BP-AUTH-016",
    "analyticsScreenName": "ms_auth_016",
    "i18nKeyPrefix": "retail.auth.resetPassword",
    "p29SectionRef": "PROMPT29:MS-AUTH-016",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-AUTH-017",
    "name": "Card Link Return",
    "surfaceKind": "route",
    "screenGroup": "AUTH",
    "businessPurpose": "Card Link Return",
    "businessCapabilityId": "CAP-AUTH-017",
    "primaryOutcome": "Customer completes card-link return and returns to account flow",
    "domain": "Auth",
    "journey": "J-CARD-LINK",
    "identityRequired": "IS-04",
    "lifecycle": "SUPPORTING_V1",
    "productScopeClass": "SUPPORTING",
    "routePath": "card/link",
    "routeComponent": "CardLinkRoute",
    "blueprintId": "BP-AUTH-017",
    "analyticsScreenName": "ms_auth_017",
    "i18nKeyPrefix": "retail.auth.cardLink",
    "p29SectionRef": "PROMPT29:MS-AUTH-017",
    "productLifecycle": "Registered",
    "certificationStatus": "draft"
  },
  {
    "id": "MS-AUTH-019",
    "name": "Complete Verification",
    "surfaceKind": "route",
    "screenGroup": "AUTH",
    "businessPurpose": "Complete Verification",
    "businessCapabilityId": "CAP-AUTH-019",
    "primaryOutcome": "Signed-in customer completes both_enforce contact verification interstitial",
    "domain": "Auth",
    "journey": "J-AUTH",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account/complete-verification",
    "routeComponent": "CompleteVerificationPage",
    "blueprintId": "BP-AUTH-019",
    "analyticsScreenName": "ms_auth_019",
    "i18nKeyPrefix": "retail.auth.completeVerification",
    "p29SectionRef": "PROMPT29:MS-AUTH-019",
    "productLifecycle": "Registered",
    "certificationStatus": "draft"
  },
  {
    "id": "MS-AUTH-020",
    "name": "Add Phone",
    "surfaceKind": "route",
    "screenGroup": "AUTH",
    "businessPurpose": "Add Phone",
    "businessCapabilityId": "CAP-AUTH-020",
    "primaryOutcome": "Signed-in customer optionally adds phone after OIDC land",
    "domain": "Auth",
    "journey": "J-AUTH",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account/add-phone",
    "routeComponent": "AddPhonePage",
    "blueprintId": "BP-AUTH-020",
    "analyticsScreenName": "ms_auth_020",
    "i18nKeyPrefix": "retail.auth.addPhone",
    "p29SectionRef": "PROMPT29:MS-AUTH-020",
    "productLifecycle": "Registered",
    "certificationStatus": "draft"
  },
  {
    "id": "MS-HUB-020",
    "name": "Shop Catalog Grid",
    "surfaceKind": "route",
    "screenGroup": "HUB",
    "businessPurpose": "Shop Catalog Grid",
    "businessCapabilityId": "CAP-SHOP-001",
    "primaryOutcome": "Customer browses shop catalog and adds products toward checkout",
    "domain": "Shop",
    "journey": "J-SHOP-PURCHASE",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "shop",
    "routeComponent": "ShopScreen",
    "childMsIds": [
      "MS-COM-037",
      "MS-HUB-021",
      "MS-HUB-027",
      "MS-SHP-041",
      "MS-SHP-043",
      "MS-SHP-044",
      "MS-SHP-046"
    ],
    "blueprintId": "BP-HUB-020",
    "analyticsScreenName": "ms_hub_020",
    "appendixTestIds": [
      "customer-sticky-cart-bar",
      "customer-shop-header-account"
    ],
    "i18nKeyPrefix": "retail.hub.shop",
    "p29SectionRef": "PROMPT29:MS-HUB-020",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-HUB-021",
    "name": "Barcode Scanner Page",
    "surfaceKind": "route",
    "screenGroup": "HUB",
    "businessPurpose": "Barcode Scanner Page",
    "businessCapabilityId": "CAP-SHOP-002",
    "primaryOutcome": "Customer scans a barcode and adds the resolved product to cart",
    "domain": "Shop",
    "journey": "J-SHOP-PURCHASE",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "shop/scanner",
    "routeComponent": "ScannerPage",
    "parentMsId": "MS-HUB-020",
    "childMsIds": [
      "MS-SHP-045"
    ],
    "blueprintId": "BP-HUB-021",
    "featureFlags": [
      "customer_shop_scanner_v1"
    ],
    "analyticsScreenName": "ms_hub_021",
    "appendixTestIds": [
      "customer-scanner-cta",
      "customer-scanner-qty-sheet"
    ],
    "i18nKeyPrefix": "retail.hub.scanner",
    "p29SectionRef": "PROMPT29:MS-HUB-021",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-HUB-022",
    "name": "Payments Receipts Tab",
    "surfaceKind": "route",
    "screenGroup": "RECEIPTS",
    "businessPurpose": "Payments Receipts Tab",
    "businessCapabilityId": "CAP-ORD-001",
    "primaryOutcome": "Signed-in customer reviews payments and receipts list",
    "domain": "Orders",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account/payments",
    "routeComponent": "AccountPaymentsPage",
    "parentMsId": "MS-HUB-025",
    "childMsIds": [
      "MS-ORD-052",
      "MS-ORD-053"
    ],
    "blueprintId": "BP-HUB-022",
    "analyticsScreenName": "ms_hub_022",
    "appendixTestIds": [
      "customer-bottom-nav-receipts"
    ],
    "i18nKeyPrefix": "retail.hub.payments",
    "p29SectionRef": "PROMPT29:MS-HUB-022",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-HUB-023",
    "name": "Account Privacy Tab",
    "surfaceKind": "route",
    "screenGroup": "PRIVACY",
    "businessPurpose": "Account Privacy Tab",
    "businessCapabilityId": "CAP-ACC-002",
    "primaryOutcome": "Signed-in customer manages account privacy and credentials",
    "domain": "Account",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account-and-privacy",
    "routeComponent": "AccountAndPrivacyPage",
    "childMsIds": [
      "MS-ACC-069",
      "MS-ACC-071",
      "MS-CON-082"
    ],
    "blueprintId": "BP-HUB-023",
    "analyticsScreenName": "ms_hub_023",
    "appendixTestIds": [
      "customer-bottom-nav-account"
    ],
    "i18nKeyPrefix": "retail.hub.accountPrivacy",
    "p29SectionRef": "PROMPT29:MS-HUB-023",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-HUB-024",
    "name": "More Route Redirect",
    "surfaceKind": "redirect",
    "screenGroup": "HUB",
    "businessPurpose": "More Route Redirect",
    "businessCapabilityId": "CAP-HUB-001",
    "primaryOutcome": "Deprecated /more path redirects into account hub navigation",
    "domain": "Hub",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "more",
    "routeComponent": "MoreRouteRedirect",
    "blueprintId": "BP-HUB-024",
    "analyticsScreenName": "ms_hub_024",
    "i18nKeyPrefix": "retail.hub.moreRedirect",
    "p29SectionRef": "PROMPT29:MS-HUB-024",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-HUB-025",
    "name": "Account Home Summary",
    "surfaceKind": "route",
    "screenGroup": "ACCOUNT",
    "businessPurpose": "Account Home Summary",
    "businessCapabilityId": "CAP-ACC-001",
    "primaryOutcome": "Signed-in customer sees account home summary and relationship cards",
    "domain": "Account",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-04",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account",
    "routeComponent": "AccountHomePage",
    "childMsIds": [
      "MS-ACC-060",
      "MS-ACC-061",
      "MS-ACC-062",
      "MS-ACC-063",
      "MS-ACC-064",
      "MS-ACC-065",
      "MS-ACC-066",
      "MS-ACC-067",
      "MS-ACC-068",
      "MS-HUB-022",
      "MS-HUB-026",
      "MS-ORD-050"
    ],
    "blueprintId": "BP-HUB-025",
    "analyticsScreenName": "ms_hub_025",
    "i18nKeyPrefix": "retail.hub.accountHome",
    "p29SectionRef": "PROMPT29:MS-HUB-025",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-HUB-026",
    "name": "More Drawer",
    "surfaceKind": "modal",
    "screenGroup": "HUB",
    "businessPurpose": "More Drawer",
    "businessCapabilityId": "CAP-HUB-001",
    "primaryOutcome": "Customer opens More drawer and navigates overflow account destinations",
    "domain": "Hub",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "MoreDrawer",
    "parentMsId": "MS-HUB-025",
    "blueprintId": "BP-HUB-026",
    "analyticsScreenName": "ms_hub_026",
    "appendixTestIds": [
      "customer-more-overflow"
    ],
    "i18nKeyPrefix": "retail.hub.moreDrawer",
    "p29SectionRef": "PROMPT29:MS-HUB-026",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-HUB-027",
    "name": "Journey Header Auth Link",
    "surfaceKind": "embedded-step",
    "screenGroup": "HUB",
    "businessPurpose": "Journey Header Auth Link",
    "businessCapabilityId": "CAP-HUB-002",
    "primaryOutcome": "Shopper reaches auth from journey header without losing browse context",
    "domain": "Hub",
    "journey": "J-SHOP-PURCHASE",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "JourneyHeaderAuthLink",
    "parentMsId": "MS-HUB-020",
    "blueprintId": "BP-HUB-027",
    "analyticsScreenName": "ms_hub_027",
    "i18nKeyPrefix": "retail.hub.headerAuthLink",
    "p29SectionRef": "PROMPT29:MS-HUB-027",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-HUB-030",
    "name": "Help Page",
    "surfaceKind": "route",
    "screenGroup": "HUB",
    "businessPurpose": "Help Page",
    "businessCapabilityId": "CAP-HUB-001",
    "primaryOutcome": "Customer reads Help topics (orders, payments, account, support) and returns to More",
    "domain": "Hub",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "help",
    "routeComponent": "HelpPage",
    "blueprintId": "BP-HUB-030",
    "analyticsScreenName": "ms_hub_030",
    "appendixTestIds": [
      "customer-help-page"
    ],
    "i18nKeyPrefix": "retail.hub.help",
    "p29SectionRef": "PROMPT29:MS-HUB-030",
    "productLifecycle": "Registered",
    "certificationStatus": "content-complete"
  },
  {
    "id": "MS-SHP-041",
    "name": "Inactive Kiosk Overlay",
    "surfaceKind": "overlay",
    "screenGroup": "SHOP",
    "businessPurpose": "Inactive Kiosk Overlay",
    "businessCapabilityId": "CAP-SHOP-001",
    "primaryOutcome": "Customer sees inactive kiosk state and chooses recovery or shop fallback",
    "domain": "Shop",
    "journey": "J-SHOP-PURCHASE",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "InactiveKioskPage",
    "parentMsId": "MS-HUB-020",
    "recoveryMsId": "MS-REC-081",
    "blueprintId": "BP-SHP-041",
    "analyticsScreenName": "ms_shp_041",
    "i18nKeyPrefix": "retail.shop.inactiveKiosk",
    "p29SectionRef": "PROMPT29:MS-SHP-041",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-SHP-042",
    "name": "Checkout Missing Session Panel",
    "surfaceKind": "overlay",
    "screenGroup": "CHECKOUT",
    "businessPurpose": "Checkout Missing Session Panel",
    "businessCapabilityId": "CAP-CHK-001",
    "primaryOutcome": "Customer without checkout session receives guided next-step options",
    "domain": "Checkout",
    "journey": "J-PHONE-FIRST-PRODUCT",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "IntentLedKioskMissingPanel",
    "parentMsId": "MS-COM-031",
    "blueprintId": "BP-SHP-042",
    "analyticsScreenName": "ms_shp_042",
    "i18nKeyPrefix": "retail.com.missingSession",
    "p29SectionRef": "PROMPT29:MS-SHP-042",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-SHP-043",
    "name": "Shop Help Modal",
    "surfaceKind": "modal",
    "screenGroup": "SHOP",
    "businessPurpose": "Shop Help Modal",
    "businessCapabilityId": "CAP-SHOP-001",
    "primaryOutcome": "Customer gets shop help copy and dismisses or continues browsing",
    "domain": "Shop",
    "journey": "J-SHOP-PURCHASE",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "KioskShopHelpModal",
    "parentMsId": "MS-HUB-020",
    "blueprintId": "BP-SHP-043",
    "analyticsScreenName": "ms_shp_043",
    "i18nKeyPrefix": "retail.shop.helpModal",
    "p29SectionRef": "PROMPT29:MS-SHP-043",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-SHP-044",
    "name": "Sticky Cart Sheet",
    "surfaceKind": "overlay",
    "screenGroup": "SHOP",
    "businessPurpose": "Sticky Cart Sheet",
    "businessCapabilityId": "CAP-SHOP-003",
    "primaryOutcome": "Customer reviews cart lines/total and continues to collect or checkout",
    "domain": "Shop",
    "journey": "J-SHOP-PURCHASE",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "CartSheet",
    "parentMsId": "MS-HUB-020",
    "blueprintId": "BP-SHP-044",
    "analyticsScreenName": "ms_shp_044",
    "appendixTestIds": [
      "customer-sticky-cart-bar",
      "customer-cart-sheet-continue",
      "shop-cart-total"
    ],
    "i18nKeyPrefix": "retail.shop.cart",
    "p29SectionRef": "PROMPT29:MS-SHP-044",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-SHP-045",
    "name": "Scanner Quantity Sheet",
    "surfaceKind": "overlay",
    "screenGroup": "SHOP",
    "businessPurpose": "Scanner Quantity Sheet",
    "businessCapabilityId": "CAP-SHOP-002",
    "primaryOutcome": "Customer confirms scanner quantity and commits line to cart",
    "domain": "Shop",
    "journey": "J-SHOP-PURCHASE",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "ScannerQuantitySheet",
    "parentMsId": "MS-HUB-021",
    "blueprintId": "BP-SHP-045",
    "analyticsScreenName": "ms_shp_045",
    "appendixTestIds": [
      "customer-scanner-qty-confirm"
    ],
    "i18nKeyPrefix": "retail.shop.scannerQty",
    "p29SectionRef": "PROMPT29:MS-SHP-045",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-SHP-046",
    "name": "Shop Search Bar",
    "surfaceKind": "embedded-step",
    "screenGroup": "SHOP",
    "businessPurpose": "Shop Search Bar",
    "businessCapabilityId": "CAP-SHOP-001",
    "primaryOutcome": "Customer filters catalog via search without leaving shop grid",
    "domain": "Shop",
    "journey": "J-SHOP-PURCHASE",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "ShopSearchBar",
    "parentMsId": "MS-HUB-020",
    "blueprintId": "BP-SHP-046",
    "analyticsScreenName": "ms_shp_046",
    "i18nKeyPrefix": "retail.shop.search",
    "p29SectionRef": "PROMPT29:MS-SHP-046",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-COM-030",
    "name": "Checkout Handoff Page",
    "surfaceKind": "route",
    "screenGroup": "CHECKOUT",
    "businessPurpose": "Checkout Handoff Page",
    "businessCapabilityId": "CAP-CHK-001",
    "primaryOutcome": "Checkout handoff token resolves into an active phone-first session",
    "domain": "Checkout",
    "journey": "J-PHONE-FIRST-PRODUCT",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "checkout/handoff",
    "routeComponent": "CheckoutHandoffPage",
    "parentMsId": "MS-COM-031",
    "recoveryMsId": "MS-REC-079",
    "blueprintId": "BP-COM-030",
    "analyticsScreenName": "ms_com_030",
    "i18nKeyPrefix": "retail.com.handoff",
    "p29SectionRef": "PROMPT29:MS-COM-030",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-COM-031",
    "name": "Phone First Product Journey",
    "surfaceKind": "route",
    "screenGroup": "CHECKOUT",
    "businessPurpose": "Phone First Product Journey",
    "businessCapabilityId": "CAP-CHK-001",
    "primaryOutcome": "Customer completes phone-first product checkout through payment success",
    "domain": "Checkout",
    "journey": "J-PHONE-FIRST-PRODUCT",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "checkout",
    "routeComponent": "PhoneFirstProductJourney",
    "childMsIds": [
      "MS-COM-030",
      "MS-COM-032",
      "MS-COM-036",
      "MS-COM-041",
      "MS-COM-043",
      "MS-COM-044",
      "MS-SHP-042"
    ],
    "blueprintId": "BP-COM-031",
    "analyticsScreenName": "ms_com_031",
    "appendixTestIds": [
      "customer-payment-method-qr",
      "customer-payment-pay-cta"
    ],
    "i18nKeyPrefix": "retail.com.phoneFirstProduct",
    "p29SectionRef": "PROMPT29:MS-COM-031",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-COM-032",
    "name": "Checkout Complete Route",
    "surfaceKind": "route",
    "screenGroup": "CHECKOUT",
    "businessPurpose": "Checkout Complete Route",
    "businessCapabilityId": "CAP-CHK-001",
    "primaryOutcome": "Customer lands on checkout-complete confirmation after paid session",
    "domain": "Checkout",
    "journey": "J-PHONE-FIRST-PRODUCT",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "checkout/complete",
    "routeComponent": "CheckoutCompleteRoute",
    "parentMsId": "MS-COM-031",
    "blueprintId": "BP-COM-032",
    "analyticsScreenName": "ms_com_032",
    "i18nKeyPrefix": "retail.com.checkoutComplete",
    "p29SectionRef": "PROMPT29:MS-COM-032",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-COM-033",
    "name": "Post Kiosk Resolver",
    "surfaceKind": "route",
    "screenGroup": "CHECKOUT",
    "businessPurpose": "Post Kiosk Resolver",
    "businessCapabilityId": "CAP-CHK-003",
    "primaryOutcome": "Post-kiosk deep link resolves to product or donation journey",
    "domain": "Checkout",
    "journey": "J-POST-KIOSK-PRODUCT",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "post-kiosk",
    "routeComponent": "PostKioskResolver",
    "childMsIds": [
      "MS-COM-034",
      "MS-COM-038",
      "MS-COM-039"
    ],
    "blueprintId": "BP-COM-033",
    "analyticsScreenName": "ms_com_033",
    "i18nKeyPrefix": "retail.com.postKioskResolver",
    "p29SectionRef": "PROMPT29:MS-COM-033",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-COM-034",
    "name": "Post Kiosk Failure Route",
    "surfaceKind": "route",
    "screenGroup": "CHECKOUT",
    "businessPurpose": "Post Kiosk Failure Route",
    "businessCapabilityId": "CAP-CHK-003",
    "primaryOutcome": "Failed post-kiosk entry shows failure state with recovery path",
    "domain": "Checkout",
    "journey": "J-POST-KIOSK-PRODUCT",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "post-kiosk-failure",
    "routeComponent": "PostKioskFailureRoute",
    "parentMsId": "MS-COM-033",
    "recoveryMsId": "MS-REC-078",
    "blueprintId": "BP-COM-034",
    "analyticsScreenName": "ms_com_034",
    "i18nKeyPrefix": "retail.com.postKioskFailure",
    "p29SectionRef": "PROMPT29:MS-COM-034",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-COM-035",
    "name": "Phone First Donation Journey",
    "surfaceKind": "route",
    "screenGroup": "DONATION",
    "businessPurpose": "Phone First Donation Journey",
    "businessCapabilityId": "CAP-DON-001",
    "primaryOutcome": "Customer completes phone-first donation through payment success",
    "domain": "Donation",
    "journey": "J-PHONE-FIRST-DONATION",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "donate",
    "routeComponent": "PhoneFirstDonationJourney",
    "blueprintId": "BP-COM-035",
    "analyticsScreenName": "ms_com_035",
    "i18nKeyPrefix": "retail.com.phoneFirstDonation",
    "p29SectionRef": "PROMPT29:MS-COM-035",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-COM-036",
    "name": "QR Payment View",
    "surfaceKind": "embedded-step",
    "screenGroup": "PAYMENT",
    "businessPurpose": "QR Payment View",
    "businessCapabilityId": "CAP-CHK-002",
    "primaryOutcome": "Customer pays via QR bank transfer and reaches paid confirmation",
    "domain": "Payment",
    "journey": "J-PAYMENT",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "QrPaymentView",
    "parentMsId": "MS-COM-031",
    "childMsIds": [
      "MS-ORD-054"
    ],
    "recoveryMsId": "MS-REC-075",
    "blueprintId": "BP-COM-036",
    "analyticsScreenName": "ms_com_036",
    "appendixTestIds": [
      "customer-payment-method-qr"
    ],
    "i18nKeyPrefix": "retail.com.qrPayment",
    "p29SectionRef": "PROMPT29:MS-COM-036",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-COM-037",
    "name": "Collect Pickup Overlay",
    "surfaceKind": "overlay",
    "screenGroup": "CHECKOUT",
    "businessPurpose": "Collect Pickup Overlay",
    "businessCapabilityId": "CAP-CHK-004",
    "primaryOutcome": "Customer confirms pickup collect preferences before checkout handoff",
    "domain": "Checkout",
    "journey": "J-SHOP-PURCHASE",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "CollectStepOverlay",
    "parentMsId": "MS-HUB-020",
    "blueprintId": "BP-COM-037",
    "analyticsScreenName": "ms_com_037",
    "appendixTestIds": [
      "customer-pickup-self-collect-checkbox",
      "customer-pickup-continue"
    ],
    "i18nKeyPrefix": "retail.com.collect",
    "p29SectionRef": "PROMPT29:MS-COM-037",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-COM-038",
    "name": "Post Kiosk Product Journey",
    "surfaceKind": "route",
    "screenGroup": "CHECKOUT",
    "businessPurpose": "Post Kiosk Product Journey",
    "businessCapabilityId": "CAP-CHK-003",
    "primaryOutcome": "Customer completes post-kiosk product payment journey",
    "domain": "Checkout",
    "journey": "J-POST-KIOSK-PRODUCT",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "PostKioskProductJourney",
    "parentMsId": "MS-COM-033",
    "childMsIds": [
      "MS-COM-045"
    ],
    "blueprintId": "BP-COM-038",
    "analyticsScreenName": "ms_com_038",
    "i18nKeyPrefix": "retail.com.postKioskProduct",
    "p29SectionRef": "PROMPT29:MS-COM-038",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-COM-039",
    "name": "Post Kiosk Donation Journey",
    "surfaceKind": "route",
    "screenGroup": "DONATION",
    "businessPurpose": "Post Kiosk Donation Journey",
    "businessCapabilityId": "CAP-DON-001",
    "primaryOutcome": "Customer completes post-kiosk donation payment journey",
    "domain": "Donation",
    "journey": "J-POST-KIOSK-DONATION",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "PostKioskDonationJourney",
    "parentMsId": "MS-COM-033",
    "blueprintId": "BP-COM-039",
    "analyticsScreenName": "ms_com_039",
    "i18nKeyPrefix": "retail.com.postKioskDonation",
    "p29SectionRef": "PROMPT29:MS-COM-039",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-COM-041",
    "name": "Checkout Receipt Panel",
    "surfaceKind": "embedded-step",
    "screenGroup": "RECEIPTS",
    "businessPurpose": "Checkout Receipt Panel",
    "businessCapabilityId": "CAP-ORD-002",
    "primaryOutcome": "Customer views checkout receipt and optional guest login upsell",
    "domain": "Orders",
    "journey": "J-RECEIPT",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "CheckoutReceiptPanel",
    "parentMsId": "MS-COM-031",
    "blueprintId": "BP-COM-041",
    "analyticsScreenName": "ms_com_041",
    "appendixTestIds": [
      "customer-receipt-login-cta",
      "customer-receipt-download-guest-helper"
    ],
    "i18nKeyPrefix": "retail.com.receiptPanel",
    "p29SectionRef": "PROMPT29:MS-COM-041",
    "aliasMsIds": [
      "MS-COM-042"
    ],
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-COM-043",
    "name": "Promo Conflict Modal",
    "surfaceKind": "modal",
    "screenGroup": "CHECKOUT",
    "businessPurpose": "Promo Conflict Modal",
    "businessCapabilityId": "CAP-PROMO-001",
    "primaryOutcome": "Customer resolves exclusive promo conflict before continuing checkout",
    "domain": "Checkout",
    "journey": "J-PROMO-ACTIVATE",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "PromoExclusiveConflictModal",
    "parentMsId": "MS-COM-031",
    "blueprintId": "BP-COM-043",
    "analyticsScreenName": "ms_com_043",
    "i18nKeyPrefix": "retail.com.promoConflict",
    "p29SectionRef": "PROMPT29:MS-COM-043",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-COM-044",
    "name": "Gateway Return Handler",
    "surfaceKind": "embedded-step",
    "screenGroup": "PAYMENT",
    "businessPurpose": "Gateway Return Handler",
    "businessCapabilityId": "CAP-CHK-002",
    "primaryOutcome": "Gateway return finalizes payment status into checkout-complete flow",
    "domain": "Payment",
    "journey": "J-PAYMENT",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "GatewayReturnComplete",
    "parentMsId": "MS-COM-031",
    "blueprintId": "BP-COM-044",
    "analyticsScreenName": "ms_com_044",
    "i18nKeyPrefix": "retail.com.gatewayReturn",
    "p29SectionRef": "PROMPT29:MS-COM-044",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-COM-045",
    "name": "Post Pay CTA",
    "surfaceKind": "embedded-step",
    "screenGroup": "ACCOUNT",
    "businessPurpose": "Post Pay CTA",
    "businessCapabilityId": "CAP-ACC-003",
    "primaryOutcome": "Post-pay CTA routes customer into account or shop next action",
    "domain": "Account",
    "journey": "J-POST-KIOSK-PRODUCT",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "PostPayCta",
    "parentMsId": "MS-COM-038",
    "blueprintId": "BP-COM-045",
    "analyticsScreenName": "ms_com_045",
    "i18nKeyPrefix": "retail.com.postPayCta",
    "p29SectionRef": "PROMPT29:MS-COM-045",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-COM-046",
    "name": "Donate Authenticated Redirect",
    "surfaceKind": "redirect",
    "screenGroup": "DONATION",
    "businessPurpose": "Donate Authenticated Redirect",
    "businessCapabilityId": "CAP-DON-001",
    "primaryOutcome": "Authenticated donate alias redirects into donation journey entry",
    "domain": "Donation",
    "journey": "J-PHONE-FIRST-DONATION",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "donate",
    "routeComponent": "DonateAuthenticatedRedirect",
    "blueprintId": "BP-COM-046",
    "analyticsScreenName": "ms_com_046",
    "i18nKeyPrefix": "retail.com.donateAuthRedirect",
    "p29SectionRef": "PROMPT29:MS-COM-046",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-PICK-040",
    "name": "Pickup Verify Page",
    "surfaceKind": "route",
    "screenGroup": "PICKUP",
    "businessPurpose": "Pickup Verify Page",
    "businessCapabilityId": "CAP-PICK-001",
    "primaryOutcome": "Customer verifies pickup eligibility and continues fulfillment path",
    "domain": "Pickup",
    "journey": "J-PICKUP-VERIFY",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "pickup/verify",
    "routeComponent": "PickupVerifyPage",
    "blueprintId": "BP-PICK-040",
    "analyticsScreenName": "ms_pick_040",
    "i18nKeyPrefix": "retail.pickup.verify",
    "p29SectionRef": "PROMPT29:MS-PICK-040",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-PICK-041",
    "name": "Find Order Page",
    "surfaceKind": "route",
    "screenGroup": "PICKUP",
    "businessPurpose": "Find Order Page",
    "businessCapabilityId": "CAP-ORD-003",
    "primaryOutcome": "Customer finds an order by lookup and opens detail or recovery",
    "domain": "Pickup",
    "journey": "J-ORDER-LOOKUP",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "orders/find",
    "routeComponent": "FindOrderPage",
    "blueprintId": "BP-PICK-041",
    "analyticsScreenName": "ms_pick_041",
    "i18nKeyPrefix": "retail.pickup.findOrder",
    "p29SectionRef": "PROMPT29:MS-PICK-041",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ORD-050",
    "name": "Account Orders List",
    "surfaceKind": "route",
    "screenGroup": "ORDERS",
    "businessPurpose": "Account Orders List",
    "businessCapabilityId": "CAP-ORD-001",
    "primaryOutcome": "Signed-in customer browses purchase history list",
    "domain": "Orders",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account/orders",
    "routeComponent": "AccountOrdersPage",
    "parentMsId": "MS-HUB-025",
    "childMsIds": [
      "MS-ORD-051"
    ],
    "blueprintId": "BP-ORD-050",
    "analyticsScreenName": "ms_ord_050",
    "appendixTestIds": [
      "customer-purchases-list"
    ],
    "i18nKeyPrefix": "retail.ord.list",
    "p29SectionRef": "PROMPT29:MS-ORD-050",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ORD-051",
    "name": "Account Order Detail",
    "surfaceKind": "route",
    "screenGroup": "ORDERS",
    "businessPurpose": "Account Order Detail",
    "businessCapabilityId": "CAP-ORD-001",
    "primaryOutcome": "Signed-in customer views order detail and buy-again / pickup actions",
    "domain": "Orders",
    "journey": "J-BUY-AGAIN",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account/orders/:id",
    "routeComponent": "AccountOrdersPage",
    "parentMsId": "MS-ORD-050",
    "childMsIds": [
      "MS-ORD-055"
    ],
    "blueprintId": "BP-ORD-051",
    "analyticsScreenName": "ms_ord_051",
    "i18nKeyPrefix": "retail.ord.detail",
    "p29SectionRef": "PROMPT29:MS-ORD-051",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ORD-052",
    "name": "Account Payment QR",
    "surfaceKind": "route",
    "screenGroup": "PAYMENT",
    "businessPurpose": "Account Payment QR",
    "businessCapabilityId": "CAP-CHK-002",
    "primaryOutcome": "Signed-in customer views payment QR for an unpaid or pending payment",
    "domain": "Payment",
    "journey": "J-PAYMENT",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account/payments/:id/qr",
    "routeComponent": "AccountPaymentQrPage",
    "parentMsId": "MS-HUB-022",
    "recoveryMsId": "MS-REC-075",
    "blueprintId": "BP-ORD-052",
    "analyticsScreenName": "ms_ord_052",
    "i18nKeyPrefix": "retail.ord.paymentQr",
    "p29SectionRef": "PROMPT29:MS-ORD-052",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ORD-053",
    "name": "Receipt Detail Panel",
    "surfaceKind": "embedded-step",
    "screenGroup": "RECEIPTS",
    "businessPurpose": "Receipt Detail Panel",
    "businessCapabilityId": "CAP-ORD-002",
    "primaryOutcome": "Customer opens receipt detail from payments/receipts context",
    "domain": "Orders",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "ReceiptDetailPanel",
    "parentMsId": "MS-HUB-022",
    "blueprintId": "BP-ORD-053",
    "analyticsScreenName": "ms_ord_053",
    "i18nKeyPrefix": "retail.ord.receipt",
    "p29SectionRef": "PROMPT29:MS-ORD-053",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ORD-054",
    "name": "Manual Reconciliation Prompt",
    "surfaceKind": "embedded-step",
    "screenGroup": "PAYMENT",
    "businessPurpose": "Manual Reconciliation Prompt",
    "businessCapabilityId": "CAP-CHK-002",
    "primaryOutcome": "Customer starts manual payment reconciliation when auto-match fails",
    "domain": "Payment",
    "journey": "J-PAYMENT",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "ManualReconciliationPrompt",
    "parentMsId": "MS-COM-036",
    "blueprintId": "BP-ORD-054",
    "analyticsScreenName": "ms_ord_054",
    "i18nKeyPrefix": "retail.ord.manualRecon",
    "p29SectionRef": "PROMPT29:MS-ORD-054",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ORD-055",
    "name": "Informational Pickup Ack Button",
    "surfaceKind": "embedded-step",
    "screenGroup": "ORDERS",
    "businessPurpose": "Informational Pickup Ack Button",
    "businessCapabilityId": "CAP-PICK-001",
    "primaryOutcome": "Customer acknowledges informational pickup status on order detail",
    "domain": "Orders",
    "journey": "J-BUY-AGAIN",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "InformationalPickupAckButton",
    "parentMsId": "MS-ORD-051",
    "blueprintId": "BP-ORD-055",
    "analyticsScreenName": "ms_ord_055",
    "i18nKeyPrefix": "retail.ord.pickupAck",
    "p29SectionRef": "PROMPT29:MS-ORD-055",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-CON-080",
    "name": "Cookie Consent Banner",
    "surfaceKind": "banner",
    "screenGroup": "CONSENT",
    "businessPurpose": "Cookie Consent Banner",
    "businessCapabilityId": "CAP-CON-001",
    "primaryOutcome": "Visitor records cookie consent choice before non-essential tracking",
    "domain": "Consent",
    "journey": "J-CONSENT",
    "identityRequired": "IS-03",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "CookieConsentBanner",
    "childMsIds": [
      "MS-CON-081"
    ],
    "blueprintId": "BP-CON-080",
    "analyticsScreenName": "ms_con_080",
    "i18nKeyPrefix": "retail.consent.banner",
    "p29SectionRef": "PROMPT29:MS-CON-080",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-CON-081",
    "name": "Marketing Consent Modal",
    "surfaceKind": "modal",
    "screenGroup": "CONSENT",
    "businessPurpose": "Marketing Consent Modal",
    "businessCapabilityId": "CAP-CON-001",
    "primaryOutcome": "Customer accepts or declines marketing/analytics consent preferences",
    "domain": "Consent",
    "journey": "J-CONSENT",
    "identityRequired": "IS-03",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "MarketingAnalyticsConsentModal",
    "parentMsId": "MS-CON-080",
    "blueprintId": "BP-CON-081",
    "analyticsScreenName": "ms_con_081",
    "i18nKeyPrefix": "retail.consent.modal",
    "p29SectionRef": "PROMPT29:MS-CON-081",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-CON-082",
    "name": "Account Privacy Consents Panel",
    "surfaceKind": "embedded-step",
    "screenGroup": "CONSENT",
    "businessPurpose": "Account Privacy Consents Panel",
    "businessCapabilityId": "CAP-CON-002",
    "primaryOutcome": "Signed-in customer updates stored privacy and consent preferences",
    "domain": "Consent",
    "journey": "J-PRIVACY",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "AccountPrivacyConsentsPanel",
    "parentMsId": "MS-HUB-023",
    "blueprintId": "BP-CON-082",
    "analyticsScreenName": "ms_con_082",
    "appendixTestIds": [
      "customer-account-privacy",
      "customer-account-credentials"
    ],
    "i18nKeyPrefix": "retail.consent.accountPanel",
    "p29SectionRef": "PROMPT29:MS-CON-082",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ACC-060",
    "name": "Account Shop Sales Points",
    "surfaceKind": "route",
    "screenGroup": "ACCOUNT",
    "businessPurpose": "Account Shop Sales Points",
    "businessCapabilityId": "CAP-ACC-001",
    "primaryOutcome": "Signed-in customer manages linked shop sales points / kiosks",
    "domain": "Account",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account/shop/sales-points",
    "routeComponent": "AccountShopKiosksPage",
    "parentMsId": "MS-HUB-025",
    "blueprintId": "BP-ACC-060",
    "analyticsScreenName": "ms_acc_060",
    "i18nKeyPrefix": "retail.acc.shopKiosks",
    "p29SectionRef": "PROMPT29:MS-ACC-060",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ACC-061",
    "name": "Account Donations List",
    "surfaceKind": "route",
    "screenGroup": "ACCOUNT",
    "businessPurpose": "Account Donations List",
    "businessCapabilityId": "CAP-DON-002",
    "primaryOutcome": "Signed-in customer reviews donation history for the tenant",
    "domain": "Account",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account/donations",
    "routeComponent": "AccountDonationsPage",
    "parentMsId": "MS-HUB-025",
    "blueprintId": "BP-ACC-061",
    "analyticsScreenName": "ms_acc_061",
    "i18nKeyPrefix": "retail.acc.donations",
    "p29SectionRef": "PROMPT29:MS-ACC-061",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ACC-062",
    "name": "Recurring Donation Setup",
    "surfaceKind": "route",
    "screenGroup": "ACCOUNT",
    "businessPurpose": "Recurring Donation Setup",
    "businessCapabilityId": "CAP-DON-002",
    "primaryOutcome": "Signed-in customer configures recurring donation preferences",
    "domain": "Account",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account/recurring-donations",
    "routeComponent": "AccountRecurringSetupPage",
    "parentMsId": "MS-HUB-025",
    "blueprintId": "BP-ACC-062",
    "analyticsScreenName": "ms_acc_062",
    "i18nKeyPrefix": "retail.acc.recurring",
    "p29SectionRef": "PROMPT29:MS-ACC-062",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ACC-063",
    "name": "Account Shop Tenant Relationship",
    "surfaceKind": "route",
    "screenGroup": "ACCOUNT",
    "businessPurpose": "Account Shop Tenant Relationship",
    "businessCapabilityId": "CAP-ACC-001",
    "primaryOutcome": "Signed-in customer manages shop tenant relationship settings",
    "domain": "Account",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routePath": "account/shop",
    "routeComponent": "AccountShopTenantPage",
    "parentMsId": "MS-HUB-025",
    "blueprintId": "BP-ACC-063",
    "analyticsScreenName": "ms_acc_063",
    "i18nKeyPrefix": "retail.acc.shopTenant",
    "p29SectionRef": "PROMPT29:MS-ACC-063",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ACC-064",
    "name": "Incomplete Purchases Section",
    "surfaceKind": "embedded-step",
    "screenGroup": "ACCOUNT",
    "businessPurpose": "Incomplete Purchases Section",
    "businessCapabilityId": "CAP-ACC-001",
    "primaryOutcome": "Customer sees incomplete purchases and resumes or abandons them",
    "domain": "Account",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-04",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "IncompletePurchasesSection",
    "parentMsId": "MS-HUB-025",
    "blueprintId": "BP-ACC-064",
    "analyticsScreenName": "ms_acc_064",
    "i18nKeyPrefix": "retail.acc.incomplete",
    "p29SectionRef": "PROMPT29:MS-ACC-064",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ACC-065",
    "name": "Promotions Card",
    "surfaceKind": "embedded-step",
    "screenGroup": "PROMOTIONS",
    "businessPurpose": "Promotions Card",
    "businessCapabilityId": "CAP-PROMO-001",
    "primaryOutcome": "Eligible customer views promotion progress on account home",
    "domain": "Promotions",
    "journey": "J-PROMO-ACTIVATE",
    "identityRequired": "IS-06",
    "lifecycle": "SUPPORTING_V1",
    "productScopeClass": "SUPPORTING",
    "routeComponent": "PromoProgressCard",
    "parentMsId": "MS-HUB-025",
    "blueprintId": "BP-ACC-065",
    "entitlementKeys": [
      "customer_promotions_v1"
    ],
    "analyticsScreenName": "ms_acc_065",
    "i18nKeyPrefix": "retail.acc.promo",
    "p29SectionRef": "PROMPT29:MS-ACC-065",
    "productLifecycle": "Registered",
    "certificationStatus": "draft"
  },
  {
    "id": "MS-ACC-066",
    "name": "Promo Rewards Card",
    "surfaceKind": "embedded-step",
    "screenGroup": "PROMOTIONS",
    "businessPurpose": "Promo Rewards Card",
    "businessCapabilityId": "CAP-PROMO-001",
    "primaryOutcome": "Eligible customer views promo rewards on account home",
    "domain": "Promotions",
    "journey": "J-PROMO-ACTIVATE",
    "identityRequired": "IS-06",
    "lifecycle": "SUPPORTING_V1",
    "productScopeClass": "SUPPORTING",
    "routeComponent": "PromoRewardsCard",
    "parentMsId": "MS-HUB-025",
    "blueprintId": "BP-ACC-066",
    "entitlementKeys": [
      "customer_promotions_v1"
    ],
    "analyticsScreenName": "ms_acc_066",
    "i18nKeyPrefix": "retail.acc.promoRewards",
    "p29SectionRef": "PROMPT29:MS-ACC-066",
    "productLifecycle": "Registered",
    "certificationStatus": "draft"
  },
  {
    "id": "MS-ACC-067",
    "name": "Loyalty Wallet Card",
    "surfaceKind": "embedded-step",
    "screenGroup": "LOYALTY",
    "businessPurpose": "Loyalty Wallet Card",
    "businessCapabilityId": "CAP-LOY-001",
    "primaryOutcome": "Eligible customer views loyalty wallet balance on account home",
    "domain": "Loyalty",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-06",
    "lifecycle": "SUPPORTING_V1",
    "productScopeClass": "SUPPORTING",
    "routeComponent": "LoyaltyWalletCard",
    "parentMsId": "MS-HUB-025",
    "blueprintId": "BP-ACC-067",
    "entitlementKeys": [
      "customer_loyalty_v1"
    ],
    "analyticsScreenName": "ms_acc_067",
    "i18nKeyPrefix": "retail.acc.loyalty",
    "p29SectionRef": "PROMPT29:MS-ACC-067",
    "productLifecycle": "Registered",
    "certificationStatus": "draft"
  },
  {
    "id": "MS-ACC-068",
    "name": "Loyalty Coupons Card",
    "surfaceKind": "embedded-step",
    "screenGroup": "LOYALTY",
    "businessPurpose": "Loyalty Coupons Card",
    "businessCapabilityId": "CAP-LOY-001",
    "primaryOutcome": "Eligible customer views loyalty coupons on account home",
    "domain": "Loyalty",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-06",
    "lifecycle": "SUPPORTING_V1",
    "productScopeClass": "SUPPORTING",
    "routeComponent": "LoyaltyCouponsCard",
    "parentMsId": "MS-HUB-025",
    "blueprintId": "BP-ACC-068",
    "entitlementKeys": [
      "customer_loyalty_v1"
    ],
    "analyticsScreenName": "ms_acc_068",
    "i18nKeyPrefix": "retail.acc.loyaltyCoupons",
    "p29SectionRef": "PROMPT29:MS-ACC-068",
    "productLifecycle": "Registered",
    "certificationStatus": "draft"
  },
  {
    "id": "MS-ACC-069",
    "name": "Step-up OTP Dialog",
    "surfaceKind": "modal",
    "screenGroup": "ACCOUNT",
    "businessPurpose": "Step-up OTP Dialog",
    "businessCapabilityId": "CAP-ACC-004",
    "primaryOutcome": "Signed-in customer completes step-up OTP for sensitive account actions",
    "domain": "Account",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "StepUpOtpDialog",
    "parentMsId": "MS-HUB-023",
    "recoveryMsId": "MS-REC-083",
    "blueprintId": "BP-ACC-069",
    "analyticsScreenName": "ms_acc_069",
    "i18nKeyPrefix": "retail.acc.stepUp",
    "p29SectionRef": "PROMPT29:MS-ACC-069",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ACC-070",
    "name": "Payment Claim Route",
    "surfaceKind": "route",
    "screenGroup": "ACCOUNT",
    "businessPurpose": "Payment Claim Route",
    "businessCapabilityId": "CAP-ACC-005",
    "primaryOutcome": "Signed-in customer claims an unpaid payment into account relationship",
    "domain": "Account",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-06",
    "lifecycle": "SUPPORTING_V1",
    "productScopeClass": "SUPPORTING",
    "routePath": "account/payments/claim",
    "routeComponent": "AccountPaymentClaimPage",
    "blueprintId": "BP-ACC-070",
    "analyticsScreenName": "ms_acc_070",
    "i18nKeyPrefix": "retail.acc.paymentClaim",
    "p29SectionRef": "PROMPT29:MS-ACC-070",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-ACC-071",
    "name": "Logout All Devices Panel",
    "surfaceKind": "embedded-step",
    "screenGroup": "SETTINGS",
    "businessPurpose": "Logout All Devices Panel",
    "businessCapabilityId": "CAP-ACC-002",
    "primaryOutcome": "Signed-in customer logs out all devices from privacy settings",
    "domain": "Account",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-06",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "AccountLogoutAllPanel",
    "parentMsId": "MS-HUB-023",
    "blueprintId": "BP-ACC-071",
    "analyticsScreenName": "ms_acc_071",
    "i18nKeyPrefix": "retail.acc.logoutAll",
    "p29SectionRef": "PROMPT29:MS-ACC-071",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-PWA-090",
    "name": "PWA Lifecycle Banner",
    "surfaceKind": "banner",
    "screenGroup": "PWA",
    "businessPurpose": "PWA Lifecycle Banner",
    "businessCapabilityId": "CAP-PWA-001",
    "primaryOutcome": "Customer installs or updates PWA and keeps payment-pending scope safe",
    "domain": "PWA",
    "journey": "J-PWA-INSTALL",
    "identityRequired": "ANY",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "PwaLifecycle",
    "recoveryMsId": "MS-REC-077",
    "blueprintId": "BP-PWA-090",
    "analyticsScreenName": "ms_pwa_090",
    "i18nKeyPrefix": "retail.pwa.lifecycle",
    "p29SectionRef": "PROMPT29:MS-PWA-090",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-NOT-090",
    "name": "Notification Preferences",
    "surfaceKind": "route",
    "screenGroup": "NOTIFICATIONS",
    "businessPurpose": "Notification Preferences",
    "businessCapabilityId": "CAP-NOT-001",
    "primaryOutcome": "Journey step complete",
    "domain": "Notifications",
    "journey": "J-ACCOUNT-RELATIONSHIP",
    "identityRequired": "IS-06",
    "lifecycle": "FUTURE",
    "productScopeClass": "FUTURE",
    "routePath": "account/notifications",
    "routeComponent": "InAppNotificationPreferences",
    "blueprintId": "BP-NOT-090",
    "analyticsScreenName": "ms_not_090",
    "i18nKeyPrefix": "retail.not.preferences",
    "p29SectionRef": "PROMPT29:MS-NOT-090",
    "productLifecycle": "Registered",
    "certificationStatus": "draft"
  },
  {
    "id": "MS-NOT-091",
    "name": "Notification Link Entry Handler",
    "surfaceKind": "handler",
    "screenGroup": "NOTIFICATIONS",
    "businessPurpose": "Notification Link Entry Handler",
    "businessCapabilityId": "CAP-NOT-002",
    "primaryOutcome": "Notification deep link resolves into the correct tenant journey entry",
    "domain": "Notifications",
    "journey": "J-SHARED",
    "identityRequired": "IS-02",
    "lifecycle": "SUPPORTING_V1",
    "productScopeClass": "SUPPORTING",
    "routeComponent": "NotificationLinkEntryHandler",
    "blueprintId": "BP-NOT-091",
    "analyticsScreenName": "ms_not_091",
    "i18nKeyPrefix": "retail.not.linkEntry",
    "p29SectionRef": "PROMPT29:MS-NOT-091",
    "productLifecycle": "Registered",
    "certificationStatus": "draft"
  },
  {
    "id": "MS-OBS-090",
    "name": "Observability Provider Shell",
    "surfaceKind": "shell",
    "screenGroup": "OBSERVABILITY",
    "businessPurpose": "Observability Provider Shell",
    "businessCapabilityId": "CAP-OBS-001",
    "primaryOutcome": "Observability provider shells customer analytics without blocking UX",
    "domain": "Observability",
    "journey": "J-SHARED",
    "identityRequired": "ANY",
    "lifecycle": "SUPPORTING_V1",
    "productScopeClass": "SUPPORTING",
    "routeComponent": "CustomerObservabilityProvider",
    "blueprintId": "BP-OBS-090",
    "analyticsScreenName": "ms_obs_090",
    "i18nKeyPrefix": "retail.obs.shell",
    "p29SectionRef": "PROMPT29:MS-OBS-090",
    "productLifecycle": "Registered",
    "certificationStatus": "draft"
  },
  {
    "id": "MS-REC-070",
    "name": "Session Expired Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Session Expired Recovery",
    "businessCapabilityId": "CAP-REC-001",
    "primaryOutcome": "Expired session recovers via sign-in with preserved return target",
    "domain": "Recovery",
    "journey": "J-IDENTITY-RECOVERY",
    "identityRequired": "ANY",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "SessionExpiredRecovery",
    "childMsIds": [
      "MS-REC-071",
      "MS-REC-072",
      "MS-REC-073",
      "MS-REC-074",
      "MS-REC-075",
      "MS-REC-076",
      "MS-REC-077",
      "MS-REC-078",
      "MS-REC-079",
      "MS-REC-080",
      "MS-REC-081",
      "MS-REC-082",
      "MS-REC-083",
      "MS-REC-084",
      "MS-REC-085",
      "MS-REC-086",
      "MS-REC-087"
    ],
    "blueprintId": "BP-REC-070",
    "analyticsScreenName": "ms_rec_070",
    "i18nKeyPrefix": "retail.rec.sessionExpired",
    "p29SectionRef": "PROMPT29:MS-REC-070",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-071",
    "name": "Offline Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Offline Recovery",
    "businessCapabilityId": "CAP-REC-002",
    "primaryOutcome": "Offline customer recovers when connectivity returns or exits safely",
    "domain": "Recovery",
    "journey": "J-SHARED",
    "identityRequired": "ANY",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "OfflineRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-071",
    "analyticsScreenName": "ms_rec_071",
    "i18nKeyPrefix": "retail.rec.offline",
    "p29SectionRef": "PROMPT29:MS-REC-071",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-072",
    "name": "No Network Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "No Network Recovery",
    "businessCapabilityId": "CAP-REC-002",
    "primaryOutcome": "No-network customer recovers when connectivity returns or exits safely",
    "domain": "Recovery",
    "journey": "J-SHARED",
    "identityRequired": "ANY",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "NoNetworkRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-072",
    "analyticsScreenName": "ms_rec_072",
    "i18nKeyPrefix": "retail.rec.noNetwork",
    "p29SectionRef": "PROMPT29:MS-REC-072",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-073",
    "name": "Maintenance Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Maintenance Recovery",
    "businessCapabilityId": "CAP-REC-003",
    "primaryOutcome": "Customer acknowledges maintenance window and retries when available",
    "domain": "Recovery",
    "journey": "J-SHARED",
    "identityRequired": "ANY",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "MaintenanceRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-073",
    "analyticsScreenName": "ms_rec_073",
    "i18nKeyPrefix": "retail.rec.maintenance",
    "p29SectionRef": "PROMPT29:MS-REC-073",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-074",
    "name": "Access Denied Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Access Denied Recovery",
    "businessCapabilityId": "CAP-REC-004",
    "primaryOutcome": "Access-denied customer recovers to allowed surface or tenant select",
    "domain": "Recovery",
    "journey": "J-SHARED",
    "identityRequired": "ANY",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "AccessDeniedRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-074",
    "analyticsScreenName": "ms_rec_074",
    "i18nKeyPrefix": "retail.rec.accessDenied",
    "p29SectionRef": "PROMPT29:MS-REC-074",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-075",
    "name": "Invalid QR Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Invalid QR Recovery",
    "businessCapabilityId": "CAP-REC-005",
    "primaryOutcome": "Invalid QR recovers to shop or re-entry without stuck payment state",
    "domain": "Recovery",
    "journey": "J-SHARED",
    "identityRequired": "ANY",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "InvalidQrRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-075",
    "analyticsScreenName": "ms_rec_075",
    "i18nKeyPrefix": "retail.rec.qrInvalid",
    "p29SectionRef": "PROMPT29:MS-REC-075",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-076",
    "name": "Unknown Error Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Unknown Error Recovery",
    "businessCapabilityId": "CAP-REC-006",
    "primaryOutcome": "Unknown error recovers via retry or safe shop fallback",
    "domain": "Recovery",
    "journey": "J-SHARED",
    "identityRequired": "ANY",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "UnknownErrorRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-076",
    "analyticsScreenName": "ms_rec_076",
    "i18nKeyPrefix": "retail.rec.unknown",
    "p29SectionRef": "PROMPT29:MS-REC-076",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-077",
    "name": "Update Required Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Update Required Recovery",
    "businessCapabilityId": "CAP-REC-007",
    "primaryOutcome": "Required PWA/app update recovers without dropping payment-pending work",
    "domain": "Recovery",
    "journey": "J-PWA-INSTALL",
    "identityRequired": "ANY",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "UpdateRequiredRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-077",
    "analyticsScreenName": "ms_rec_077",
    "i18nKeyPrefix": "retail.rec.updateRequired",
    "p29SectionRef": "PROMPT29:MS-REC-077",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-078",
    "name": "Post Kiosk Invalid Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Post Kiosk Invalid Recovery",
    "businessCapabilityId": "CAP-REC-008",
    "primaryOutcome": "Invalid post-kiosk entry recovers to resolver or shop fallback",
    "domain": "Recovery",
    "journey": "J-POST-KIOSK-PRODUCT",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "PostKioskInvalidRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-078",
    "analyticsScreenName": "ms_rec_078",
    "i18nKeyPrefix": "retail.rec.postKioskInvalid",
    "p29SectionRef": "PROMPT29:MS-REC-078",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-079",
    "name": "Handoff Expired Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Handoff Expired Recovery",
    "businessCapabilityId": "CAP-REC-009",
    "primaryOutcome": "Expired checkout handoff recovers to shop with clear restart path",
    "domain": "Recovery",
    "journey": "J-PHONE-FIRST-PRODUCT",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "HandoffExpiredRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-079",
    "analyticsScreenName": "ms_rec_079",
    "i18nKeyPrefix": "retail.rec.handoffExpired",
    "p29SectionRef": "PROMPT29:MS-REC-079",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-080",
    "name": "Payment Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Payment Recovery",
    "businessCapabilityId": "CAP-REC-010",
    "primaryOutcome": "Payment failure recovers to retry payment or abandon safely",
    "domain": "Recovery",
    "journey": "J-PAYMENT",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "PaymentRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-080",
    "analyticsScreenName": "ms_rec_080",
    "i18nKeyPrefix": "retail.rec.payment",
    "p29SectionRef": "PROMPT29:MS-REC-080",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-081",
    "name": "Tenant Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Tenant Recovery",
    "businessCapabilityId": "CAP-REC-011",
    "primaryOutcome": "Tenant context failure recovers to tenant select or allowed tenant",
    "domain": "Recovery",
    "journey": "J-SHARED",
    "identityRequired": "IS-01",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "TenantRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-081",
    "analyticsScreenName": "ms_rec_081",
    "i18nKeyPrefix": "retail.rec.tenant",
    "p29SectionRef": "PROMPT29:MS-REC-081",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-082",
    "name": "Interrupted Journey Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Interrupted Journey Recovery",
    "businessCapabilityId": "CAP-REC-012",
    "primaryOutcome": "Interrupted journey recovers from checkpoint or safe restart",
    "domain": "Recovery",
    "journey": "J-SHARED",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "InterruptedJourneyRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-082",
    "analyticsScreenName": "ms_rec_082",
    "i18nKeyPrefix": "retail.rec.interrupted",
    "p29SectionRef": "PROMPT29:MS-REC-082",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-083",
    "name": "Login Identity Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Login Identity Recovery",
    "businessCapabilityId": "CAP-REC-013",
    "primaryOutcome": "Login/identity failure recovers to sign-in with return target",
    "domain": "Recovery",
    "journey": "J-IDENTITY-RECOVERY",
    "identityRequired": "IS-02",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "LoginIdentityRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-083",
    "analyticsScreenName": "ms_rec_083",
    "i18nKeyPrefix": "retail.rec.identity",
    "p29SectionRef": "PROMPT29:MS-REC-083",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-084",
    "name": "Permission Required Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Permission Required Recovery",
    "businessCapabilityId": "CAP-REC-014",
    "primaryOutcome": "Missing permission recovers via grant path or allowed fallback",
    "domain": "Recovery",
    "journey": "J-SHARED",
    "identityRequired": "ANY",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "PermissionRequiredRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-084",
    "analyticsScreenName": "ms_rec_084",
    "i18nKeyPrefix": "retail.rec.permission",
    "p29SectionRef": "PROMPT29:MS-REC-084",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-085",
    "name": "Expired Permission Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Expired Permission Recovery",
    "businessCapabilityId": "CAP-REC-015",
    "primaryOutcome": "Expired permission recovers via re-grant or allowed fallback",
    "domain": "Recovery",
    "journey": "J-SHARED",
    "identityRequired": "ANY",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "ExpiredPermissionRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-085",
    "analyticsScreenName": "ms_rec_085",
    "i18nKeyPrefix": "retail.rec.expiredPermission",
    "p29SectionRef": "PROMPT29:MS-REC-085",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-086",
    "name": "Generic Retry Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "Generic Retry Recovery",
    "businessCapabilityId": "CAP-REC-016",
    "primaryOutcome": "Transient failure recovers via generic retry without data loss",
    "domain": "Recovery",
    "journey": "J-SHARED",
    "identityRequired": "ANY",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "GenericRetryRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-086",
    "analyticsScreenName": "ms_rec_086",
    "i18nKeyPrefix": "retail.rec.retry",
    "p29SectionRef": "PROMPT29:MS-REC-086",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  },
  {
    "id": "MS-REC-087",
    "name": "General Business Error Recovery",
    "surfaceKind": "overlay",
    "screenGroup": "RECOVERY",
    "businessPurpose": "General Business Error Recovery",
    "businessCapabilityId": "CAP-REC-017",
    "primaryOutcome": "Business rule error recovers with explained next step or exit",
    "domain": "Recovery",
    "journey": "J-SHARED",
    "identityRequired": "ANY",
    "lifecycle": "CORE_V1",
    "productScopeClass": "CORE",
    "routeComponent": "GeneralBusinessErrorRecovery",
    "parentMsId": "MS-REC-070",
    "blueprintId": "BP-REC-087",
    "analyticsScreenName": "ms_rec_087",
    "i18nKeyPrefix": "retail.rec.generalError",
    "p29SectionRef": "PROMPT29:MS-REC-087",
    "productLifecycle": "Registered",
    "certificationStatus": "blueprint-complete"
  }
] as const satisfies readonly MasterScreenEntry[];
